import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=1c2a72ac&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c2a72ac')) {
      api.createRecord('1c2a72ac', component.options)
    } else {
      api.reload('1c2a72ac', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=1c2a72ac&", function () {
      api.rerender('1c2a72ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oTD4RQ9Q1UWQ/JS/comp/FavElement.vue"
export default component.exports